import { render, staticRenderFns } from "./AboutStrategy.vue?vue&type=template&id=4dfe8842&scoped=true"
import script from "./AboutStrategy.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutStrategy.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AboutStrategy.vue?vue&type=style&index=0&id=4dfe8842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe8842",
  null
  
)

export default component.exports